import { createSlice } from '@reduxjs/toolkit';

export const initialToastState = {
  open: false,
  type: 'success',
  text: ''
};

const toastSlice = createSlice({
  name: 'toast',
  initialState: initialToastState,
  reducers: {
    handleToast: (state, action) => {
      state.open = action.payload.open;
      state.type = action.payload.type;
      state.text = action.payload.text;
    },
    handleDefaultToast: (state) => {
      state.open = true;
      state.type = 'error';
      state.text = 'Error de servidor, intentá nuevamente';
    },
    handleCloseToast: () => initialToastState
  },
  extraReducers: () => {},
});

export const { handleToast, handleDefaultToast, handleCloseToast } = toastSlice.actions;
export default toastSlice.reducer;
